{
  "sdk-download-android": "Ladda ned för Android",
  "sdk-connect": "Anslut",
  "sdk-download-ios": "Ladda ned för iOS",
  "sdk-install": "Installera",
  "sdk-modal-instruct-1": "1. Öppna Binance-appen",
  "sdk-modal-instruct-2": "2. Tryck på {{icon}} på startskärmen",
  "sdk-modal-title": "Anslut med Binance",
  "sdk-no-app": "Har du inte Binance-appen ännu?"
}